var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-10-01
 * @brief EHP Check Sheet 관리 개발
 *
 ********************************************************************/
import React, { useState } from "react";
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState } from "../../../recoil/menuState";
import { langState } from '../../../recoil/langState';
//utils
import * as CONST from "../../../utils/Const";
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import clog from "../../../utils/logUtils";
//component
import CheckSheetTree from "./CheckSheetTree";
import SpgCheckCRUD from "./spgcheck/SpgCheckCRUD";
/**
 * @brief EHP Check Sheet 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function MenuMain(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadingBox] = useRecoilState(loadingBoxState);
    const [langs, setRecoilLangs] = useRecoilState(langState); // recoil langState
    //
    const [isMobile, setIsMobile] = useState(false);
    const [adminType, setAdminType] = useState("SPG-VCB"); // SPG
    // LIST, CREATE, UPDATE, DELETE, READ, BATCH, SET
    const [workMode, setWorkMode] = useState("INIT");
    const defaultTree = {
        spg: { spgId: "", spgName: "" },
        reload: false
    };
    const [selTree, setSelTree] = useState(defaultTree);
    //
    const [spgVersion, setSpgVersion] = useState(null);
    const [versionList, setVersionList] = useState(null);
    function handleSelTree(adminType, treeInfo) {
        // => 선택 후, version 정보 가지고 오는 형태로 바꿈.....
        setSpgVersion(null);
        setVersionList(null);
        //
        setAdminType(adminType);
        setSelTree(treeInfo);
        //
        clog("IN MAIN : HANDLE TREE : " + JSON.stringify(treeInfo) + "" + workMode);
        if ((treeInfo.reload) || ((treeInfo.spg.spgName.length > 0) && (workMode === "LIST"))) {
            //if ( (treeInfo.spg.spgName.length > 0) ) {
            doGetSpgVersion(treeInfo);
        }
    }
    function doGetSpgVersion(tree) {
        return __awaiter(this, void 0, void 0, function* () {
            //clog("doGetSpgVersion : " + JSON.stringify(tree));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "GET",
                "appPath": `/api/v2/checksheet/spg/versions`,
                "appQuery": {
                    "spgName": tree.spg.spgName,
                },
                "userToken": userInfo.loginInfo.token,
                "watch": workMode + selTree
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    clog("doGetSpgVersion : " + JSON.stringify(data.body));
                    setVersionList(data.body);
                    data.body.filter((sver) => sver.enabled).map((sver, idx) => {
                        if (idx === 0)
                            setSpgVersion(sver);
                    });
                }
            }
            return data;
        });
    }
    function handleSpgVersion(version) {
        clog("IN MAIN : HANDLE TREE : " + JSON.stringify(selTree) + "" + workMode);
        if ((selTree.reload) || ((selTree.spg.spgName.length > 0) && (workMode === "LIST"))) {
            //if ( (treeInfo.spg.spgName.length > 0) ) {
            doGetSpgVersion(selTree);
        }
    }
    clog("CHECK SPG MAIN : INIT : " + workMode);
    return (React.createElement(React.Fragment, null,
        React.createElement(CheckSheetTree, { selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, adminType: adminType, setAdminType: setAdminType, setPopWin: props.setPopWin }),
        (adminType.includes("SPG")) && React.createElement(SpgCheckCRUD, { isMobile: isMobile, setIsMobile: setIsMobile, selTree: selTree, setSelTree: handleSelTree, workMode: workMode, setWorkMode: setWorkMode, adminType: adminType, setPopWin: props.setPopWin, 
            //
            //pageInfo={pageInfo}
            //setPageInfo={setPageInfo}
            versionList: versionList, spgVersion: spgVersion, setSpgVersion: setSpgVersion })));
}
export default MenuMain;
